import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import React from 'react';
import ImageLoader from '../../images/ImageLoader';

var RewardRedemptionCard = function RewardRedemptionCard(props) {
  var _selectedValues$rewar3, _selectedValues$rewar4, _selectedValues$rewar5;

  var _props$model = props.model,
      model = _props$model === void 0 ? {} : _props$model,
      _props$recommended = props.recommended,
      recommended = _props$recommended === void 0 ? false : _props$recommended,
      selectedValues = props.selectedValues,
      setSelectedValues = props.setSelectedValues,
      available = props.available;
  var Image = model.Image,
      DisplayName = model.DisplayName,
      Expiration = model.Expiration,
      ExternalId = model.ExternalId,
      Code = model.Code;

  var handleClick = function handleClick(id, code) {
    var _selectedValues$rewar, _selectedValues$rewar2;

    if (!available) return;
    if (!(selectedValues === null || selectedValues === void 0 ? void 0 : (_selectedValues$rewar = selectedValues.rewards) === null || _selectedValues$rewar === void 0 ? void 0 : _selectedValues$rewar.includes(id)) && (selectedValues === null || selectedValues === void 0 ? void 0 : (_selectedValues$rewar2 = selectedValues.rewards) === null || _selectedValues$rewar2 === void 0 ? void 0 : _selectedValues$rewar2.length) === 12) return;
    setSelectedValues(function (prev) {
      var _prev$rewards;

      if (prev && ((_prev$rewards = prev.rewards) === null || _prev$rewards === void 0 ? void 0 : _prev$rewards.length)) {
        return _objectSpread(_objectSpread({}, prev), {}, {
          rewards: prev.rewards.some(function (obj) {
            return obj.code === code;
          }) ? prev.rewards.filter(function (reward) {
            return reward.code !== code;
          }) : [].concat(_toConsumableArray(prev.rewards), [{
            id: id,
            code: code
          }])
        });
      } else {
        return _objectSpread(_objectSpread({}, prev), {}, {
          rewards: [{
            id: id,
            code: code
          }]
        });
      }
    });
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "reward-redemption-card \n                    ".concat(!available ? 'reward-redemption-card--unavailable' : '', " \n                    ").concat((selectedValues === null || selectedValues === void 0 ? void 0 : (_selectedValues$rewar3 = selectedValues.rewards) === null || _selectedValues$rewar3 === void 0 ? void 0 : _selectedValues$rewar3.length) === 12 && !(selectedValues === null || selectedValues === void 0 ? void 0 : (_selectedValues$rewar4 = selectedValues.rewards) === null || _selectedValues$rewar4 === void 0 ? void 0 : _selectedValues$rewar4.some(function (obj) {
      return obj.code === Code.value;
    })) ? 'reward-redemption-card--unavailable' : '', " \n                    ").concat((selectedValues === null || selectedValues === void 0 ? void 0 : (_selectedValues$rewar5 = selectedValues.rewards) === null || _selectedValues$rewar5 === void 0 ? void 0 : _selectedValues$rewar5.some(function (obj) {
      return obj.code === Code.value;
    })) ? 'reward-redemption-card--selected' : ''),
    onClick: function onClick() {
      return handleClick(ExternalId === null || ExternalId === void 0 ? void 0 : ExternalId.value, Code === null || Code === void 0 ? void 0 : Code.value);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: 'reward-redemption-card__image-container'
  }, /*#__PURE__*/React.createElement(ImageLoader, {
    media: Image,
    type: 'product',
    className: "reward-redemption-card__image"
  }), /*#__PURE__*/React.createElement("div", {
    className: "reward-redemption-card__tag ".concat(recommended ? 'reward-redemption-card__tag--show' : '')
  }, "Recommended")), /*#__PURE__*/React.createElement("div", {
    className: 'reward-redemption-card__body-container'
  }, /*#__PURE__*/React.createElement("div", {
    className: 'reward-redemption-card__header'
  }, DisplayName === null || DisplayName === void 0 ? void 0 : DisplayName.value), /*#__PURE__*/React.createElement("div", {
    className: 'reward-redemption-card__expiration'
  }, Expiration.value && "Expires ".concat(Expiration.value)))));
};

export default RewardRedemptionCard;